import { useLocation } from "react-router";
import AppStoreBadge from '@/component/common/AppStoreBadge';
import { PATHS } from '@/navigation/paths';
import styles from "./headerMenu.module.scss";

/**
 * HomeAppStoreBadge - the App Store badge in the header, on the home page
 * only. Both menus (signed in and signed out) render this, so the badge and
 * its home-page check live in one place instead of a copy per menu.
 *
 * Hidden on phones (see headerMenu.module.scss): the row there has no room
 * beside the icons, and the badge in the home page's hero carousel still
 * reaches phone visitors.
 */
const HomeAppStoreBadge = () => {
  const { pathname } = useLocation();
  if (pathname !== PATHS.home) return null;

  return (
    <div className={styles.appStore}>
      <AppStoreBadge size="sm" />
    </div>
  );
};

export default HomeAppStoreBadge;
